import { AxiosResponse } from 'axios';

import { UDNICK } from '../../../../../service/udnick';
import { IFilter } from 'store/ducks/coletaNoCd/types';

export interface INotas {
  nuNota: number;
  volume: string;
  quantidade: number;
  descricaoProduto: string;
  codProduto: number;
  controle: string;
  referencia: string;
  quantidadePendente: number;
  valorTotal: number;
  pesoBruto: number;
}

interface IGetNotas {
  itensNota: INotas[];
}

export const ColetaNoCdServices = {
  getAllData: (
    codCdd: number | undefined,
    filtro: IFilter | undefined,
    parceiros: number,
    tamanhoPagina: number | undefined
  ): Promise<AxiosResponse> =>
    UDNICK.callService(
      'getColetas',
      {
        codCdd,
        filtro,
        parceiros,
      },
      { tamanhoPagina }
    ),

  getColetas: (
    cddAtivo: number,
    inscricoesEstaduais: number,
    ordenacao: any
  ): Promise<AxiosResponse> =>
    UDNICK.callService('getColetas', {
      centroDistribuicao: cddAtivo,
      inscricoesEstaduais: inscricoesEstaduais,
      ordenacao,
    }),
};

export const ItensNota = {
  getItensNota: (nuNota: number): Promise<AxiosResponse<IGetNotas>> =>
    UDNICK.callService('getItensNota', {
      nuNota,
    }),
};
